import React from 'react';
import { Grid, Row, Col } from '../utils/bootstrap';
import Modal from '../components/Modal';

export default class Template extends React.Component {
  render() {
    return (
      <Modal history={this.props.history}>
        <Grid>
          <Row>
            <Col xs={12}>
              <h3>DISCLAIMER</h3>
              <p>
                This information is provided for general discussion purposes only, and does not take
                into account your personal objectives, individual financial situation or financial
                needs. This information does not serve as a replacement for sound accounting,
                professional or financial advice or consultation. Before deciding to act upon any
                information found herein you must assess its appropriateness to your own financial
                needs. Premium Capital Partners is not authorised as a deposit-taking institution,
                and Premium Capital Partners' obligations do not represent deposits or other such
                liabilities from other financial institutions.
              </p>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/Disclaimer.js